(function () {
    const form = document.querySelector('[data-form-subscribe]');

    if (form) {
        const input = form.querySelector('#phone_number');

        const checkForm = (elem) => {
            form.classList.add('error')

            const messages = form.querySelectorAll('.form__message-text')
            if (messages) messages.forEach(msg => msg.style.display = 'none')

            let valid = false

            if (!elem) {
                form.querySelector('.form__message-empty').style.display = 'block';
            } else if (elem === 'user-exist') {
                form.querySelector('.form__message-user').style.display = 'block';
            } else if (elem.length !== 9) {
                form.querySelector('.form__message-length').style.display = 'block';
            } else if (elem.length === 9 && +elem[0] !== 7) {
                form.querySelector('.form__message-digit').style.display = 'block';
            } else {
                valid = true
                form.classList.remove('error')
            }

            return valid
        }

        if (input) {
            input.addEventListener('input', (e) => {
                if (e.target.value[0] !== '7') e.target.value = ''
            });
        }

        form.addEventListener('submit', (e) => {
            e.preventDefault()

            const obj = {}
            const formData = new FormData(form)
            const header = {'Content-Type': 'application/json'}

            obj.target_url = "https://cashxloan.online/?utm_source=cashxloan&utm_medium=cpc&utm_campaign=facebook_leads";

            for (let entity of formData.entries()) {
                if (entity[0] === 'phone_number' && entity[1] !== '') {
                    obj.username = entity[1].match(/\d+/g).join('')
                }
            }

            const validate = checkForm(obj.username)
            if (!validate) return false

            const json = JSON.stringify(obj)

            fetch(API_USERS, {
                headers: header,
                method: 'POST',
                body: json,
            })
                .then(response => {
                    return response.json();
                })
                .then((response) => {
                    if (response && response.user) {
                        const modals = document.querySelectorAll('[data-modal]');

                        if (modals) {
                            modals.forEach(modal => modal.classList.remove('modal_active'));

                            document.querySelector('[data-modal="confirm"]').classList.add('modal_active');
                        }
                    } else {
                        window.location.href = (ICL_LANGUAGE_CODE === 'en') ?
                            `https://cashx.lk/en/user/login/?utm_source=cashxloan&utm_medium=site` :
                            `https://cashx.lk/user/login/?utm_source=cashxloan&utm_medium=site`
                    }
                })
                .catch((error) => {
                    console.log(error);
                });

            form.reset()
        });
    }
})();
